import { useMutation } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { PatientTreatmentSchedule, PutPatientTreatmentScheduleArgs } from "../schemas/Treatment";

export const usePutPatientTreatmentSchedule = () => {
  const client = useApiClient();

  return useMutation<PatientTreatmentSchedule, Error, PutPatientTreatmentScheduleArgs>({
    mutationFn: args => client.putPatientTreatmentSchedule(args),
  });
};
